import { VenuesSearchBar } from "./VenuesSearchBar";

export default VenuesSearchBar;
